const txt = 'Below you will find the projects and presentations to which I have contributed.';

export default txt;
